import React from "react";
import {
  AlertsList,
  IncidentsList,
  OnCallList,
  Analytics,
  Layout,
} from "@k-phoen/backstage-plugin-opsgenie";
import { PostMortemTab } from "../PostMortemTab";

export type OpsgeniePageProps = {
  onCallListCardsCount?: number;
};

export const OpsgeniePage = ({ onCallListCardsCount }: OpsgeniePageProps) => {
  return (
    <Layout>
      <Layout.Route path="who-is-on-call" title="Who is on-call">
        <OnCallList cardsPerPage={onCallListCardsCount} />
      </Layout.Route>
      <Layout.Route path="alerts" title="Alerts">
        <AlertsList />
      </Layout.Route>
      <Layout.Route path="incidents" title="Incidents">
        <IncidentsList />
      </Layout.Route>
      <Layout.Route path="analytics" title="Analytics">
        <Analytics />
      </Layout.Route>
      <Layout.Route path="post-mortem-form" title="Post Mortem Form">
        <PostMortemTab />
      </Layout.Route>
    </Layout>
  );
};
